import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';

const RequireAuth = () => {
  const { currentUser } = useAuth();
  
  return currentUser ? <Outlet /> : <Navigate to="/login" />;
};

export default RequireAuth;
